define('core/utils/object/extend',[
    'core/utils/collection/each',
    'core/utils/object/has',
], function (
    each,
    has
) {
    'use strict';

    // Borrowed from underscore
    return function extend(obj) {
        each(Array.prototype.slice.call(arguments, 1), function (source) {
            for (var prop in source) {
                if (has(source, prop))
                    obj[prop] = source[prop];
            }
        });
        return obj;
    };
});

